module.exports = __webpack_public_path__ + "img/sd-modified.80a69a6.png";